import api from '../axiosConfig';

const API_URL = '/api/reports';

export const fetchGoldStockAddedReport = (filters = {}) => {
  return api.get(`${API_URL}/gold-stock-added`, { params: filters });
};